import { Injectable } from '@angular/core';
import { Pwa } from './pwa.service';

@Injectable({
  providedIn: 'root',
})
export class SwipeNavigation {
  constructor(private pwa: Pwa) {}

  /**
   * Enables Swipe Gestures thats performs back / forward navigation
   * This is only available in IOS at the moment
   */
  async enableSwipeGestures(val: boolean) {
    if (!this.pwa.isNative() && this.pwa.getPlatform() !== 'ios') {
      return;
    }

    const {
      SwipeNavigation: swipeNavigationPlugin,
    } = await this.pwa.capacitorPlugins();

    if (val) {
      swipeNavigationPlugin.enable();
    } else {
      swipeNavigationPlugin.disable();
    }
  }
}
